module.exports = __webpack_public_path__ + "static/8-ccce4b7ff33ed8b920bd34522225bcbf.jpg";